/**
 * This will evaluate a media query string e.g. "(max-width: 450px)"
 *
 * An option callback is passed in, with this will be executed when the window changes size
 *
 * @param {string} mediaQueryString
 * @param {function} callback
 */
export const matchMedia = (mediaQueryString, callback) => {
  // validate there is an input
  if (!mediaQueryString) {
    return null;
  }
  // make sure the browser supports matchMedia
  if (window.matchMedia) {
    const mq = window.matchMedia(mediaQueryString);
    if (typeof callback === "function") {
      mq.addListener(callback);
    }
    return mq;
  }
  return null;
};